export function extrairMensagemErro(err: any, mensagemPadrao = 'Ocorreu um erro. Tente novamente.'): string {
  return err?.error?.detalhe || err?.error?.detail || err?.error?.message || mensagemPadrao;
}
